import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const BanksCTA = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-5xl md:text-6xl font-bold mb-6 text-white">
          Move Banking Teams Forward—
          <br />
          <span className="text-cyan-400">One Conversation at a Time</span>
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-4xl mx-auto">
          Traain helps financial institutions train smarter, communicate better, and deliver consistent, high-trust service.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={openCalendly}
            className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
            data-testid="banks-cta-demo-btn"
          >
            See Traain for Banks & Credit Unions
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default BanksCTA;
